import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCallback, useRef, useState } from 'react';
import { Flex } from 'foundations-components/components/Flex';
import { useShareToolContext } from '../../context/ShareToolContext';
import { USER_SETTINGS, saveUserSetting } from '../../api/userSettingsAPI';
import { standaloneTrackInteraction } from '../../usage-tracker/standaloneTrack';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { CloseButton } from 'foundations-components/transitional/components/CloseButton';
import { Button } from 'foundations-components/transitional/components/Button';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const WriteManualEmailButton = ({
  emailCommunicatorUrl,
  buttonLabel,
  tooltipMainText,
  disabled
}) => {
  const {
    userSettings,
    userSettingsLoading
  } = useShareToolContext();
  const [showTooltip, setShowTooltip] = useState(false);
  const ignoreUserSettingValue = useRef(false);
  const handleWriteEmailButtonClick = useCallback(() => {
    standaloneTrackInteraction({
      action: 'click write manual email button'
    });
    if (userSettingsLoading) {
      ignoreUserSettingValue.current = true;
    }
    const shouldShowTooltip = ignoreUserSettingValue.current || userSettings[USER_SETTINGS.HIDE_MANUAL_EMAIL_BUTTON_POPOVER] !== 'true';
    if (shouldShowTooltip) {
      setShowTooltip(true);
    } else if (emailCommunicatorUrl) {
      window.location.assign(emailCommunicatorUrl);
    }
  }, [userSettingsLoading, userSettings, emailCommunicatorUrl]);
  const handleConfirmButtonClick = useCallback(() => {
    saveUserSetting(USER_SETTINGS.HIDE_MANUAL_EMAIL_BUTTON_POPOVER, 'true');
    if (emailCommunicatorUrl) {
      window.location.assign(emailCommunicatorUrl);
    }
  }, [emailCommunicatorUrl]);
  const handleCloseClick = useCallback(() => {
    setShowTooltip(false);
  }, []);
  return /*#__PURE__*/_jsx(Tooltip, {
    inlineSize: "350px",
    maxInlineSize: "350px",
    headingText: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "row",
      children: [/*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "CommerceToolsUiLib.shareToolModal.emailTab.writeManualEmailButton.tooltip.headingText"
        })
      }), /*#__PURE__*/_jsx(View, {
        marginInline: "400",
        as: "div",
        children: /*#__PURE__*/_jsx(CloseButton, {
          color: "icon-core-subtle",
          onClick: handleCloseClick,
          size: "sm"
        })
      })]
    }),
    title: /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsxs(View, {
        marginBlock: "400",
        as: "div",
        children: [/*#__PURE__*/_jsx("p", {
          children: tooltipMainText || /*#__PURE__*/_jsx(FormattedMessage, {
            message: "CommerceToolsUiLib.shareToolModal.emailTab.writeManualEmailButton.tooltip.bodyText"
          })
        }), /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "CommerceToolsUiLib.shareToolModal.emailTab.writeManualEmailButton.tooltip.bodyText1"
          })
        })]
      }), /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "row",
        children: [/*#__PURE__*/_jsx(Button, {
          use: "primary",
          onClick: handleConfirmButtonClick,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "CommerceToolsUiLib.shareToolModal.emailTab.writeManualEmailButton.tooltip.confirmButton"
          })
        }), /*#__PURE__*/_jsx(Button, {
          use: "tertiary-light",
          onClick: handleCloseClick,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "CommerceToolsUiLib.shareToolModal.emailTab.writeManualEmailButton.tooltip.cancelButton"
          })
        })]
      })]
    }),
    open: showTooltip,
    use: "longform",
    placement: "top",
    children: /*#__PURE__*/_jsx(Tooltip, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "CommerceToolsUiLib.shareToolModal.emailTab.writeManualEmailButton.disabledTooltip.bodyText"
      }),
      disabled: !disabled,
      children: /*#__PURE__*/_jsx(Button, {
        use: "secondary",
        responsive: false,
        onClick: handleWriteEmailButtonClick,
        disabled: disabled,
        children: buttonLabel || /*#__PURE__*/_jsx(FormattedMessage, {
          message: "CommerceToolsUiLib.shareToolModal.emailTab.writeManualEmailButton.text"
        })
      })
    })
  });
};